import { useGT } from 'gt-react';
import { cn } from 'src/lib/utils';
import { spanWallTime, type RunClock } from './spanClock';
import type { Span } from './types';
import { fmtMs } from './utils';

/** When the row started, as local wall-clock time; the full timestamp is on hover. */
export function SpanStartTime({
  clock,
  span,
}: {
  clock: RunClock | null | undefined;
  span: Span;
}) {
  if (!clock) return null;
  const { label, full } = spanWallTime(clock, span);
  return (
    <time
      dateTime={new Date(clock.runStartMs + span.startMs).toISOString()}
      title={full}
      className="font-mono text-[10.5px] tabular-nums text-stone-400"
    >
      {label}
    </time>
  );
}

/**
 * How long the row took — only when that was actually measured (`Span.timedDurMs`). Anything else
 * would be a guess, like the gap until the next row, so an untimed row shows a quiet dash that says
 * so on hover rather than a number that looks measured.
 */
export function SpanDuration({
  span,
  className,
}: {
  span: Span;
  className?: string;
}) {
  const gt = useGT();
  const timed = span.timedDurMs;
  if (timed != null) {
    return <span className={className}>{fmtMs(timed)}</span>;
  }
  return (
    <span
      className={cn(className, 'text-stone-300')}
      title={gt('Not timed', {
        context:
          'agent trace: tooltip on a blank duration — this row has no recorded start and end time',
      })}
    >
      —
    </span>
  );
}
